import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class VehicleDutyCycleInsightsService {

  constructor(private readonly httpClient: HttpClient) { }

  getCurrentTempInsights(deviceSerialNumber: string[]):Observable<any> {
    return this.httpClient.get<any>(environment.apiEndpoint + 'current-duty-cycle-insights?batteryIdentifiers=' + deviceSerialNumber);
  }
}
